import axios from "axios";

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const InfoPicher = {
    async show() {
        get_token();
        try {
            return await axios.get('/statement_hostel/pichers/student_info/show');
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_record_book() {
        get_token();
        try {
            return await axios.get('/statement_hostel/pichers/student_info/get_record_book');
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_privilege() {
        get_token();
        try {
            return await axios.get('/statement_hostel/pichers/stm_hostel_settler/get_privilege');
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async fluorography() {
        get_token();
        try {
            return await axios.get('/statement_hostel/pichers/student_info/fluorography');
        } catch (e) {
            console.log("Error");
            return null;
        }
    }
}

export default InfoPicher;